export const REGEX = {
  ALPHABETS: /^[A-Za-z\s]+$/i,
  ALPHANUMERIC: /^[A-Za-z0-9]+$/i,
  NUMBER: /^[0-9]+$/i,
}